import { themeDark, themeLight } from './colors';

export const getColorTheme = (theme) => {
	return theme === 'light' ? themeLight : themeDark;
};
